// Port of api/fuel/app/classes/filter/search/games/filters/query/other/artists.php
import DB from 'offline/db'
import Util from 'offline/util'
export default {
	name: 'other.artists',
	priority: 75,
	require: function(config, filter) {
		return filter.artists && filter.artists.length > 0
	},
	run: function(config, filter, data, query) {
		var include = [], exclude = []
		for (var i = 0; i < filter.artists.length; i++) {
			var d = filter.artists[i]
			if (d < 0) exclude.push(-d)
			else include.push(d)
		}
		if (include.length) {
			var games = DB.query('SELECT game_id AS g FROM game_artist WHERE artist_id IN(' + Util.in(include) + ') GROUP BY game_id HAVING COUNT(DISTINCT(artist_id)) = ' + include.length)
			var ids = Util.pluck(games, 'g')
			if (ids.length) query.where('g.game_id', 'in', ids)
			else query.where('g.game_id', '=', 0)
		}
		if (exclude.length) {
			var exGames = DB.query('SELECT game_id AS g FROM game_artist WHERE artist_id IN(' + Util.in(exclude) + ')')
			var exIds = Util.pluck(exGames, 'g')
			if (exIds.length) query.where('g.game_id', 'not in', exIds)
		}
	}
}
